import {Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Paragraph} = Typography;

const CommunicationSM = () => {
  return (
    <Layout style={{background: appColors['ColorG'], margin: '5% 0 5% 0'}}>
      <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '-4%'}}>Our Social Media:</Paragraph>
    </Layout>
  );
};

export default CommunicationSM;
